// extracted by mini-css-extract-plugin
module.exports = {"label":"home-tags__label","open":"home-tags__open","list":"home-tags__list","active":"home-tags__active","all":"home-tags__all"};